module.exports = __webpack_public_path__ + "img/icon_per.21f13ea1.png";